import { getCalculatorData } from "../context";
import {
  CalculatorOption,
  CalculatorProduct,
  CalculatorState,
  InferValuesTypes,
  Kit,
  ServiceType,
  VendorCatalog,
} from "../types";
import { data } from "./../demo";

type ActionTypes = ReturnType<InferValuesTypes<typeof actions>>;

const actions = {
  setKits: (payload: Kit[]) => ({ type: "SET_KITS", payload } as const),
  setVendors: (payload: VendorCatalog[]) =>
    ({ type: "SET_VENDORS", payload } as const),
  setCurrentVendor: (payload: VendorCatalog) =>
    ({ type: "SET_CURRENT_VENDOR", payload } as const),
  setCurrentProducts: (payload: CalculatorProduct[]) =>
    ({ type: "SET_CURRENT_PRODUCTS", payload } as const),
  setCurrentOptions: (payload: CalculatorOption[]) =>
    ({ type: "SET_CURRENT_OPTIONS", payload } as const),
  setCurrentVendorIndex: (payload: number) =>
    ({ type: "SET_CURRENT_VENDOR_INDEX", payload } as const),
  setCurrentKitIndex: (payload: number) =>
    ({ type: "SET_CURRENT_KIT_INDEX", payload } as const),
  setProductsQty: (payload: {
    qty: number;
    productId: number;
    productType: "equipment" | "option";
  }) => ({ type: "SET_PRODUCTS_QTY", payload } as const),
  setProductsSum: (payload: number) =>
    ({ type: "SET_PRODUCTS_SUM", payload } as const),
  setOptionsSum: (payload: number) =>
    ({ type: "SET_OPTIONS_SUM", payload } as const),
  setServiceType: (payload: ServiceType) =>
    ({ type: "SET_SERVICE_TYPE", payload } as const),
  setSum: () => ({ type: "SET_SUM" } as const),
  /**
   * Set equipment setup sum from product.setup
   */
  setSetupSum: () => ({ type: "SET_SETUP_SUM" } as const),
};

function calculatorReducer(
  state: CalculatorState,
  action: ActionTypes
): CalculatorState {
  switch (action.type) {
    case "SET_KITS":
      return { ...state, serviceKits: [...action.payload] };

    case "SET_SERVICE_TYPE":
      return {
        ...state,
        serviceType: action.payload,
        serviceKits: getCalculatorData(data, action.payload).kits,
        currentVendors: [
          ...getCalculatorData(data, action.payload).kits[0].vendors,
        ], // NOTE: maybe indexes will be better choice
        currentVendor: getCalculatorData(data, action.payload).kits[0]
          .vendors[0], // NOTE: maybe indexes will be better choice
        currentProducts: getCalculatorData(data, action.payload).kits[0]
          .vendors[0].products, // NOTE: maybe indexes will be better choice
        serviceOptions: getCalculatorData(data, action.payload).kits[0].options,
        currentKitIndex: 0,
        currentVendorIndex: 0,
        productsSum: getCalculatorData(data, action.payload).kits[0].vendors[0]
          .base_cost,
        optionsSum: getCalculatorData(data, action.payload).kits[0]
          .subscription_min,
        setupSum: getCalculatorData(data, action.payload).kits[0].vendors[0]
          .setup,
      };

    case "SET_VENDORS":
      return {
        ...state,
        currentVendors: [...action.payload],
      };

    case "SET_CURRENT_VENDOR_INDEX":
      return { ...state, currentVendorIndex: action.payload };

    case "SET_CURRENT_VENDOR":
      return { ...state, currentVendor: { ...action.payload } };

    case "SET_CURRENT_KIT_INDEX":
      return { ...state, currentKitIndex: action.payload };

    case "SET_CURRENT_PRODUCTS": {
      const products: CalculatorProduct[] | [] = action.payload.map(
        (product) => {
          return {
            ...product,
            qty: product.initial ? product.initial : 0,
          };
        }
      );
      return { ...state, currentProducts: [...products] };
    }

    case "SET_CURRENT_OPTIONS": {
      const options: CalculatorOption[] | [] = action.payload.map((product) => {
        return {
          ...product,
          qty: product.initial ? product.initial : 0,
        };
      });
      return { ...state, serviceOptions: [...options] };
    }

    case "SET_PRODUCTS_SUM": {
      console.log("set products sum");
      // @ts-nocheck
      const { currentProducts } = state;
      // @ts-expect-error
      const sum: number = currentProducts.reduce(
        // @ts-expect-error
        (prev: number, curr: CalculatorProduct) => {
          // initial price for products included in kit
          const initialQty = curr.initial ? curr.initial : 0;
          if (!curr.qty || curr.qty == 0) {
            return prev;
          } else {
            return prev + curr.qty * curr.price - curr.price * initialQty;
          }
        },
        action.payload
      );

      return { ...state, productsSum: sum };
    }

    case "SET_PRODUCTS_QTY":
      const { productId, qty, productType } = action.payload;
      const productsByType: CalculatorOption[] | CalculatorProduct[] | [] =
        productType === "option" ? state.serviceOptions : state.currentProducts;
      const products: CalculatorOption[] | CalculatorProduct[] | [] =
        productsByType.map((product, i) => {
          if (productId === i) return { ...product, qty };
          return product;
        });
      if (productType === "option") {
        return { ...state, serviceOptions: products };
      } else {
        return { ...state, currentProducts: products as CalculatorProduct[] };
      }

    case "SET_OPTIONS_SUM": {
      console.log("set options sum");
      // @ts-nocheck
      const { serviceOptions } = state;
      // @ts-expect-error
      const optionsSum: number = serviceOptions.reduce(
        // @ts-expect-error
        (prev: number, curr: CalculatorOption) => {
          // initial price for products included in kit
          const initialQty = curr.initial ? curr.initial : 0;
          if (!curr.qty || curr.qty == 0) {
            return prev;
          } else {
            return (
              prev +
              curr.qty * curr.subscription -
              initialQty * curr.subscription
            );
          }
        },
        action.payload
      );
      return { ...state, optionsSum: optionsSum };
    }

    case "SET_SETUP_SUM": {
      console.log("set options sum");
      // @ts-nocheck
      const { currentProducts, currentVendors, currentVendorIndex } = state;
      // @ts-expect-error
      const setupSum: number = currentProducts.reduce(
        // @ts-expect-error
        (prev: number, curr: CalculatorProduct) => {
          // initial price for products included in kit
          const initialQty = curr.initial ? curr.initial : 0;
          const setupCost = currentVendors[currentVendorIndex].setup;
          if (!curr.qty || curr.qty == 0) {
            return prev;
          } else {
            return prev + curr.qty * setupCost - initialQty * setupCost;
          }
        },
        0
      );
      return { ...state, setupSum };
    }

    default:
      return state;
  }
}

// In any other file just imort reducer, action and use this
// const [state, dispatch] = useReducer(reducer, initialState);
export { calculatorReducer, actions, ActionTypes };
